export default "__VITE_ASSET__6d9c2413__"